import { Button, Paper, Stack, Typography, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/', { replace: true });
  };

  return (
    <PaperStyled>
      <StackStyled gap={5}>
        <Typography variant="h5" color="surface.700">
          Oops!
        </Typography>
        <Typography variant="body1" color="surface.700">
          <b>404</b> | Halaman Tidak Ditemukan
        </Typography>
        <Button variant="contained" sx={{ maxWidth: 200 }} onClick={goToHome}>
          Kembali ke Beranda
        </Button>
      </StackStyled>
    </PaperStyled>
  );
};

const PaperStyled = styled(Paper)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(5)
}));

const StackStyled = styled(Stack)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

export default PageNotFound;
